import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { X, SlidersHorizontal } from "lucide-react";
import { PHASE_KEYS, PROJECT_STATUS } from "@/lib/workflow";
import { ERP_READINESS, SCOPE_OPTIONS, EMPTY_FILTERS, activeFilterCount } from "@/lib/dashboard";

function Sel({ value, onChange, placeholder, options, testId }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-9 bg-white border-slate-200 text-sm" data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>{options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}</SelectContent>
    </Select>
  );
}

export function DashboardFilters({ canWide, scope, setScope, filters, setFilters, options }) {
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v }));
  const count = activeFilterCount(filters);

  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50/70 p-3" data-testid="dashboard-filters">
      <div className="flex items-center gap-2 mb-3">
        <SlidersHorizontal className="h-4 w-4 text-slate-500" />
        <span className="overline">Filters</span>
        {canWide ? (
          <div className="ml-2 inline-flex rounded-lg border border-slate-200 bg-white p-0.5" data-testid="dashboard-scope-toggle">
            {SCOPE_OPTIONS.map((o) => (
              <button key={o.value} onClick={() => setScope(o.value)} data-testid={`scope-${o.value}-btn`}
                className={`px-3 py-1 text-xs font-medium rounded-md transition ${scope === o.value ? "bg-[#2563EB] text-white" : "text-slate-600 hover:text-slate-900"}`}>
                {o.label}
              </button>
            ))}
          </div>
        ) : (
          <span className="ml-2 text-xs text-slate-500" data-testid="dashboard-scope-locked">Showing your projects only</span>
        )}
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-6 gap-2">
        {canWide && (
          <Sel value={filters.pm_id} onChange={set("pm_id")} placeholder="Project Manager" testId="dashboard-filter-pm"
            options={[{ value: "all", label: "All managers" }, ...(options.managers || []).map((m) => ({ value: m.user_id, label: m.name }))]} />
        )}
        <Sel value={filters.customer} onChange={set("customer")} placeholder="Customer" testId="dashboard-filter-customer"
          options={[{ value: "all", label: "All customers" }, ...(options.customers || []).map((c) => ({ value: c, label: c }))]} />
        <Sel value={filters.brand} onChange={set("brand")} placeholder="Brand" testId="dashboard-filter-brand"
          options={[{ value: "all", label: "All brands" }, ...(options.brands || []).map((b) => ({ value: b, label: b }))]} />
        <Sel value={filters.status_filter} onChange={set("status_filter")} placeholder="Status" testId="dashboard-filter-status" options={PROJECT_STATUS} />
        <Sel value={filters.phase} onChange={set("phase")} placeholder="Phase" testId="dashboard-filter-phase" options={PHASE_KEYS} />
        <Sel value={filters.erp_readiness} onChange={set("erp_readiness")} placeholder="ERP readiness" testId="dashboard-filter-erp" options={ERP_READINESS} />
        <div className="flex items-center gap-1">
          <Input type="date" value={filters.date_from} onChange={(e) => set("date_from")(e.target.value)} className="dash-date h-9 bg-white border-slate-200 text-xs" data-testid="dashboard-filter-date-from" />
          <span className="text-slate-400 text-xs">→</span>
          <Input type="date" value={filters.date_to} onChange={(e) => set("date_to")(e.target.value)} className="dash-date h-9 bg-white border-slate-200 text-xs" data-testid="dashboard-filter-date-to" />
        </div>
        {count > 0 && (
          <Button variant="ghost" className="h-9 justify-start text-slate-500 col-span-2 lg:col-span-1" onClick={() => setFilters(EMPTY_FILTERS)} data-testid="dashboard-filters-clear">
            <X className="h-4 w-4 mr-1" />Clear {count}
          </Button>
        )}
      </div>
    </div>
  );
}
